import { Accordion } from "../../../components/utilities";

const DetailsWrapper = ({ children, collapsedByDefault = false, gap = 1, ...rest }) => <Accordion defaultActiveKey={collapsedByDefault === true ? "1" : "0"} gap={gap} {...rest}>{children}</Accordion>

export default DetailsWrapper;